export default __webpack_public_path__ + "static/media/goopter-robots-disinfection.c8163686.png";